var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddHospitalButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3003_17477)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 2.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9547 16.1896C23.9566 16.0736 23.9354 15.9583 23.8923 15.8505C23.8492 15.7427 23.785 15.6444 23.7036 15.5616C23.6222 15.4787 23.5252 15.4127 23.4182 15.3677C23.3112 15.3226 23.1963 15.2993 23.0803 15.299C22.9643 15.2988 22.8495 15.3217 22.7426 15.3663C22.6356 15.4109 22.5387 15.4764 22.4575 15.559C22.3763 15.6416 22.3124 15.7395 22.2695 15.8472C22.2267 15.9548 22.2057 16.07 22.2078 16.186L22.2148 21.1367L17.2649 21.129C17.1476 21.1246 17.0308 21.144 16.9213 21.1858C16.8118 21.2276 16.712 21.2911 16.6277 21.3725C16.5434 21.4538 16.4765 21.5514 16.4308 21.6593C16.3851 21.7672 16.3617 21.8833 16.3618 22.0006C16.362 22.1179 16.3858 22.234 16.4319 22.3421C16.4779 22.4501 16.5452 22.5479 16.6297 22.6295C16.7142 22.7111 16.8143 22.7749 16.9239 22.8171C17.0335 22.8593 17.1504 22.879 17.2676 22.875L22.2167 22.8852L22.2244 27.8351C22.2328 28.0614 22.3286 28.2758 22.4917 28.4333C22.6548 28.5907 22.8724 28.6789 23.0988 28.6793C23.3251 28.6796 23.5425 28.5921 23.7051 28.4352C23.8677 28.2782 23.9629 28.0641 23.9705 27.8379L23.9644 22.8863L28.9151 22.8949C29.1413 22.8873 29.3554 22.7922 29.5124 22.6295C29.6693 22.4669 29.7569 22.2496 29.7565 22.0232C29.7561 21.7969 29.6679 21.5792 29.5105 21.4161C29.353 21.253 29.1386 21.1572 28.9124 21.1489L23.9633 21.1386L23.9547 16.1896Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3003_17477",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3003_17477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3003_17477",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHospitalButton);
export default __webpack_public_path__ + "static/media/AddHospitalButton.0f2fa593d9ba30c8dee46a13bc44e3dd.svg";
export { ForwardRef as ReactComponent };